<template>
  <material-card color="Cyan" :title="`Faturas`" text="">
    <v-data-table
      :headers="headers"
      :items="invoices"
      hide-actions
      :loading="true"
      no-data-text="Não há faturas para esse membro"
      v-if="!loading"
    >
      <template slot="headerCell" slot-scope="{ header }">
        <span
          class="subheading text-xs-right font-weight-light text-success text--darken-3"
          v-text="header.text"
        />
      </template>
      <template slot="items" slot-scope="{ item }">
        <td @click="editInvoice(item)">{{ item.competence | formatarData }}</td>
        <td class="text-xs-right">R$ {{ item.amount | formatCurrency }}</td>
        <td class="text-xs-right">R$ {{ item.total | formatCurrency }}</td>
        <td class="text-xs-right">R$ {{ item.discount | formatCurrency }}</td>
        <td class="text-xs-right">
          <v-icon
            v-if="
              item.status !== 'paga' &&
              item.status !== 'succeeded' &&
              item.status !== 'paid'
            "
            >{{ item.status | formatBillingStatus }}</v-icon
          >
          <v-icon
            color="primary"
            v-if="
              item.status === 'paga' ||
              item.status === 'succeeded' ||
              item.status === 'paid'
            "
            >{{ item.status | formatBillingStatus }}</v-icon
          >
          <span v-if="item.status === 'failed'">{{
            item.transaction_error.message_display
          }}</span>
        </td>
        <td class="text-xs-center">
          <v-icon @click="sendDemonstrativo(item)">email</v-icon>
        </td>
        <td class="text-xs-center" v-if="!item.bill_url">
          <v-icon @click="invoiceSelected(item)">cloud_upload</v-icon>
        </td>
        <td class="text-xs-center" v-if="item.bill_url">
          <v-icon @click="showBill(item)" color="success"
            >cloud_download</v-icon
          >
        </td>
        <!-- <td class="text-xs-right">
                <v-menu bottom offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn 
                    v-on="on"
                    color="success"
                    v-if="item.transaction_status !== 'succeeded' && item.status !== 'paga'"
                    :loading="loading_faturar"
                    :disabled="loading_faturar"
                    >{{item.transaction_status?'Refaturar':'Faturar'}}</v-btn>
                </template>
                <v-list>
                    <v-list-tile v-for="(item_faturar, i) in items_faturar" :key="i" @click="faturar(buyer, buyer.buyer_id, item.item, item_faturar.type)">
                    <v-list-tile-title>{{ item_faturar.title }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
                </v-menu>
            </td> -->
      </template>
    </v-data-table>
    <v-progress-linear
      v-if="loading"
      height="2"
      v-slot:loading
      color="cyan"
      indeterminate
    ></v-progress-linear>
    <cpn-add-bill :invoice="invoice"></cpn-add-bill>
    <cpn-show-bill :invoice="invoice"></cpn-show-bill>
  </material-card>
</template>
<script>
// import { EventBus } from '../../event-bus'
import XLSX from "xlsx";
import AddBill from "./AddBill";
import ShowBill from "./ShowBill";
import { eventBus } from "../../main";
import { enviarEmail } from "../../services/sendmail";
import { GET_BILLING_DETAIL } from "../../graphql/billing";
import { sendInvoice } from "../../services/billing";
import moment from "moment";

export default {
  props: ["loading", "customer_id", "invoices"],
  data: () => ({
    loading_email: false,
    dialog: false,
    invoice: {},
    loading_faturar: false,
    month_desc: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    sender: "contato@enercred.com.br",
    total: 0,
    cols: [],
    data: [
      [
        "Indice",
        "Competencia",
        "Nome",
        // 'UC',
        "Créditos kW",
        "% de Aluguel",
        "Créditos",
        "Mensalidade",
        "Taxa",
        "Receita Liquida",
        "Economia",
        "Método de Pagamento",
        "Status",
      ],
    ],
    headers: [
      {
        sortable: false,
        text: "Competencia",
        value: "competence",
      },
      {
        sortable: false,
        text: "Créditos",
        value: "amount",
      },
      {
        sortable: false,
        text: "Mensalidade",
        value: "total",
      },
      {
        sortable: false,
        text: "Economia",
        value: "discount",
      },
      {
        sortable: false,
        text: "Status",
        value: "status",
      },
      {
        sortable: false,
        text: "",
        value: "enviaEmail",
      },
      // {
      //     sortable: false,
      //     text: ' ',
      //     value: 'faturar'
      // }
    ],
    items_faturar: [
      {
        title: "Cartão de Crédito",
        type: "credit",
      },
      {
        title: "Boleto",
        type: "boleto",
      },
    ],
  }),
  components: {
    cpnAddBill: AddBill,
    cpnShowBill: ShowBill,
  },
  filters: {
    formatBillingStatus: function (value) {
      if (!value) return "";
      if (value === "paga" || value === "succeeded" || value === "paid") {
        return "done_outline";
      } else if (
        value === "aberta" ||
        value === "pending" ||
        value === "waiting_payment"
      ) {
        return "schedule";
      } else if (value === "free") {
        return "free_breakfast";
      } else {
        return "error";
      }
    },
  },
  methods: {
    invoiceSelected(invoice) {
      this.dialog2 = true;
      invoice.customer_id = this.customer_id;
      eventBus.$emit("invoiceSelected", invoice);
      eventBus.$emit("customer_id", this.customer_id);
    },
    showBill(invoice) {
      this.dialogShowBill = true;
      eventBus.$emit("showBill", invoice);
    },
    _export(items) {
      /* convert state to workbook */
      items.forEach((item, index) => {
        item.id = index;
        /*
              var ucs = [];
              item.consumer_units.forEach(uc => {
                  ucs.push(uc.consumer_unit)
              })
              */
        this.data.push([
          index + 1,
          item.competence,
          item.name || 0,
          // ucs,
          item.amount_kW * 1,
          item.amount_kW / this.total,
          item.amount * 1,
          item.total * 1,
          item.fees * 1 || 0,
          (item.total - item.fees) * 1 || 0,
          item.discount * 1,
          item.payment_type || "",
          item.status || "",
        ]);
        // console.log('data: ', this.data)
      });
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();

      const file = "faturamento_" + this.formatFileName(new Date());
      // XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      XLSX.utils.book_append_sheet(wb, ws, file);
      /* generate file and send to client */
      XLSX.writeFile(wb, file + ".xlsx");
    },
    formatFileName(value) {
      if (!value) return "";
      const year = value.getYear();
      const month = value.getMonth() + 1;
      const day = value.getDay();
      const hour = value.getHours();
      const minute = value.getMinutes();
      return day + "" + month + "" + year + "" + hour + "" + minute;
    },
    async sendDemonstrativo(item) {
      await this.$apollo
        .query({
          // gql query
          query: GET_BILLING_DETAIL,
          // Reactive parameters
          variables: {
            // Use vue reactive properties here
            power_plant_id: item.power_plant_id,
            competence: item.competence,
            customer_id: this.customer_id,
          },
        })
        .then(async (billings) => {
          const billing = billings.data.billing[0];
          await sendInvoice(billing.id, localStorage.getItem("token"));
        })
        .catch((error) => {
          console.error("Erro ao pegar o detalhes da fatura: ", error);
        });
    },
    async sendEmail(data) {
      this.loading_email = true;
      enviarEmail(data);
      this.loading_email = false;
    },
    async sendDemonstrativoBoletoSemCustoDisp(user, billing) {
      const msg = {
        email: user.email,
        name: user.name,
        template_id: "d-de7a69485f49433d9bb26bc9ea0ec1af",
        dynamic_template_data: {
          name: user.name,
          competence: this.formatCompetence(billing.competence),
          // total_amount: this.formatCurrencyEmail(billing.total_amount),
          amount: this.formatCurrencyEmail(billing.amount),
          total_payment: this.formatCurrencyEmail(
            billing.total * 1 + billing.total_invoice * 1,
          ),
          discount: this.formatCurrencyEmail(billing.discount) || 0,
          total_invoice: this.formatCurrencyEmail(billing.total_invoice),
          total_bill: this.formatCurrencyEmail(billing.total_utility_company),
          total: this.formatCurrencyEmail(billing.total) || 0,
          transaction_date: billing.updated_at
            ? moment(billing.updated_at).format("DD/MM/YYYY HH:MM")
            : moment(new Date()).format("DD/MM/YYYY HH:MM"),
          transaction_status: this.formatStatus(billing.transaction.status),
          payment_method: "Boleto",
          transaction_id: billing.transaction.id || "",
          barcode: billing.transaction.boleto_barcode || "",
          vencimento:
            moment(billing.transaction.boleto_expiration_date).format(
              "DD/MM/YYYY",
            ) || "",
          url: billing.transaction.boleto_url,
        },
      };
      if (billing.bills && billing.bills[0].base64String) {
        const filename = "conta-concessionaria-" + billing.competence + ".pdf";
        const bill_base64String = [
          {
            content: billing.bills[0].base64String,
            filename: filename,
            disposition: "attachment",
          },
        ];
        msg.attachments = bill_base64String;
      }
      // return this.sendEmail(JSON.parse(JSON.stringify(msg)))
      return enviarEmail(JSON.parse(JSON.stringify(msg)));
    },

    async sendDemonstrativoBoletoComCustoDisp(user, billing) {
      const msg = {
        // to: {
        //     email: user.email,
        //     name: user.name
        // },
        // name: user.name,
        // from: {
        //     email: this.sender,
        //     name: 'Enercred :: Energia Limpa e Barata'
        // },
        email: user.email,
        name: user.name,
        template_id: "d-033b28e2141f434eb150fe6dda336f42",
        dynamic_template_data: {
          name: user.name,
          competence: this.formatCompetence(billing.competence),
          transaction_date: billing.updated_at
            ? moment(billing.updated_at).format("DD/MM/YYYY HH:MM")
            : moment(new Date()).format("DD/MM/YYYY HH:MM"),
          transaction_status: this.formatStatus(billing.transaction.status),
          payment_method: "Boleto",
          transaction_id: billing.transaction.id || "",
          barcode: billing.transaction.boleto_barcode || "",
          vencimento:
            moment(billing.transaction.boleto_expiration_date).format(
              "DD/MM/YYYY",
            ) || "",
          url: billing.transaction.boleto_url || "",
          total_bill: this.formatCurrencyEmail(billing.total_utility_company),
          custo_disp: billing.custo_disp
            ? this.formatCurrencyEmail(billing.custo_disp)
            : 0,
          amount: this.formatCurrencyEmail(billing.amount) || 0,
          total_invoice: this.formatCurrencyEmail(billing.total_invoice) || 0,
          total: this.formatCurrencyEmail(billing.total) || 0,
          total_payment:
            this.formatCurrencyEmail(
              billing.total * 1 + billing.total_invoice * 1,
            ) || 0,
          discount: this.formatCurrencyEmail(billing.discount) || 0,
          economia_label: this.formatLabel(billing.discount) || 0,
        },
      };
      if (billing.bills && billing.bills[0].base64String) {
        const filename = "conta-concessionaria-" + billing.competence + ".pdf";
        const bill_base64String = [
          {
            content: billing.bills[0].base64String,
            filename: filename,
            disposition: "attachment",
          },
        ];
        msg.attachments = bill_base64String;
      }
      // return this.sendEmail(JSON.parse(JSON.stringify(msg)))
      return enviarEmail(JSON.parse(JSON.stringify(msg)));
    },

    async sendDemonstrativoCardSemCustoDisp(user, billing) {
      const msg = {
        // to: {
        //     email: user.email,
        //     name: user.name
        // },
        // name: user.name,
        email: user.email,
        name: user.name,
        // from: {
        //     email: this.sender,
        //     name: 'Enercred :: Energia Limpa e Barata'
        // },
        template_id: "d-c23725fa01df42308fa75c0b7f3f8830",
        dynamic_template_data: {
          name: user.name,
          competence: this.formatCompetence(billing.competence),
          transaction_date: billing.updated_at
            ? moment(billing.updated_at).format("DD/MM/YYYY HH:MM")
            : moment(new Date()).format("DD/MM/YYYY HH:MM"),
          transaction_status: this.formatStatus(billing.transaction.status),
          payment_method: "Cartão de Crédito",
          transaction_id: billing.transaction.id || "",
          total_bill: this.formatCurrencyEmail(billing.total_utility_company),
          amount: this.formatCurrencyEmail(billing.amount) || 0,
          total_invoice: this.formatCurrencyEmail(billing.total_invoice) || 0,
          total: this.formatCurrencyEmail(billing.total) || 0,
          total_payment:
            this.formatCurrencyEmail(
              billing.total * 1 + billing.total_invoice * 1,
            ) || 0,
          discount: this.formatCurrencyEmail(billing.discount) || 0,
          economia_label: this.formatLabel(billing.discount) || 0,
        },
      };
      if (billing.bills && billing.bills[0].base64String) {
        const filename = "conta-concessionaria-" + billing.competence + ".pdf";
        const bill_base64String = [
          {
            content: billing.bills[0].base64String,
            filename: filename,
            disposition: "attachment",
          },
        ];
        msg.attachments = bill_base64String;
      }
      // return enviarEmail(JSON.parse(JSON.stringify(msg)))
      return enviarEmail(JSON.parse(JSON.stringify(msg)));
    },

    async sendDemonstrativoCardComCustoDisp(user, billing) {
      const msg = {
        // from: {
        //     email: this.sender,
        //     name: 'Enercred :: Energia Limpa e Barata'
        // },
        email: user.email,
        name: user.name,
        template_id: "d-73a70a3782874dd18a13fd734d0b2208",
        personalizations: [
          {
            // to: {
            //     email: user.email,
            //     name: user.name
            // },
            email: user.email,
            name: user.name,
            // bcc: this.sender,
            dynamic_template_data: {
              name: user.name,
              competence: this.formatCompetence(billing.competence),
              transaction_date: billing.updated_at
                ? moment(billing.updated_at).format("DD/MM/YYYY HH:MM")
                : moment(new Date()).format("DD/MM/YYYY HH:MM"),
              transaction_status: this.formatStatus(billing.transaction.status),
              payment_method: "Cartão de Crédito",
              transaction_id: billing.transaction.id || "",
              total_bill: this.formatCurrencyEmail(
                billing.total_utility_company,
              ),
              custo_disp: billing.custo_disp
                ? this.formatCurrencyEmail(billing.custo_disp)
                : 0,
              amount: this.formatCurrencyEmail(billing.amount) || 0,
              total_invoice:
                this.formatCurrencyEmail(billing.total_invoice) || 0,
              total: this.formatCurrencyEmail(billing.total) || 0,
              total_payment:
                this.formatCurrencyEmail(
                  billing.total * 1 + billing.total_invoice * 1,
                ) || 0,
              discount: this.formatCurrencyEmail(billing.discount) || 0,
              economia_label: this.formatLabel(billing.discount) || 0,
            },
          },
        ],
      };
      if (billing.bills && billing.bills[0].base64String) {
        const filename = "conta-concessionaria-" + billing.competence + ".pdf";
        const bill_base64String = [
          {
            content: billing.bills[0].base64String,
            filename: filename,
            disposition: "attachment",
          },
        ];
        msg.attachments = bill_base64String;
      }
      // return this.sendEmail(msg
      return enviarEmail(JSON.parse(JSON.stringify(msg)));
    },
    formatCompetence(competence) {
      const month_comp = this.month_desc[competence.split("-")[1] - 1];
      const year_comp = competence.split("-")[0];
      return month_comp + " de " + year_comp;
    },

    formatLabel(discount) {
      return discount > 0 ? "Você Economizou" : "Não houve economia";
    },

    formatCurrencyEmail(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    formatStatus(status) {
      if (status === "") return "";
      if (status === "pending") return "Aguardando Pagamento";
      if (status === "paid") return "Fatura Paga";
      if (status === "succeeded") return "Fatura Paga";
      if (status === "failed") return "Falha ao realizar cobrança";
      if (status === "processing")
        return "Transação está em processo de autorização.";
      if (status === "authorized")
        return "Transação foi autorizada. Cliente possui saldo na conta e este valor foi reservado para futuro faturamento.";
      if (status === "refunded") return "Transação estornada completamente.";
      if (status === "waiting_payment") return "Aguardando pagamento.";
      if (status === "refused")
        return "Transação recusada, não autorizada. Por favor, entre em contato conosco.";
      if (status === "analyzing")
        return "Transação encaminhada para a análise manual feita por um especialista em prevenção a fraude.";
      if (status === "pending_review")
        return "Transação pendente de revisão manual.";
    },
  },
};
</script>
